"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return "\n    <rect y=\"4\" width=\"104\" height=\"42\" rx=\"4\" fill=\"black\" fill-opacity=\"0.8\"/>\n    <rect x=\"28\" y=\"25\" width=\"10\" height=\"11\" rx=\"2\" fill=\"#8BDDFF\"/>\n    <rect x=\"66\" y=\"25\" width=\"10\" height=\"11\" rx=\"2\" fill=\"#8BDDFF\"/>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 4H29L12 46H4L21 4Z\" fill=\"white\" fill-opacity=\"0.4\"/>\n";
};